import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from "vue"
import useTimePositionMapping from "../composables/useTimePositionMapping"
import dayjs from "dayjs"
import provideConfig from "../provider/provideConfig"


export default /*#__PURE__*/_defineComponent({
  __name: 'GGanttCurrentTime',
  setup(__props) {

const { mapTimeToPosition } = useTimePositionMapping()
const currentMoment = ref(dayjs())
const { colors, dateFormat, currentTimeLabel } = provideConfig()
const xDist = computed(() => {
  const format = dateFormat.value || "YYYY-MM-DD HH:mm"
  return mapTimeToPosition(dayjs(currentMoment.value, format).format(format))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "g-grid-current-time",
    style: _normalizeStyle({
      left: `${xDist.value}px`
    })
  }, [
    _createElementVNode("div", {
      class: "g-grid-current-time-marker",
      style: _normalizeStyle({
        border: `1px dashed ${_unref(colors).markerCurrentTime}`
      })
    }, null, 4),
    _createElementVNode("span", {
      class: "g-grid-current-time-text",
      style: _normalizeStyle({ color: _unref(colors).markerCurrentTime })
    }, [
      _renderSlot(_ctx.$slots, "current-time-label", {}, () => [
        _createTextVNode(_toDisplayString(_unref(currentTimeLabel)), 1)
      ])
    ], 4)
  ], 4))
}
}

})